// extracted by mini-css-extract-plugin
module.exports = {"graphic":"Image__graphic__VquGE","spinnerWrapper":"Image__spinnerWrapper__10rJD","spinner":"Image__spinner__2_FF_"};